module.exports = __webpack_public_path__ + "media/images/samplePick-1c368529f1955624ac5717bbff372a8c.png";